
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic02Off as ObiHydraulic02OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-02-off.js';
 
 
 

 
 export const ObiHydraulic02Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-02-off',
   elementClass: ObiHydraulic02OffElement,
   events: {
     
   }
  });
 
 